<mat-card #statusBar *ngIf="isVisible()" class="statusbar" style="border-radius: 30px;">
  <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" style="margin-left: 2px;">
    <span class="counters-box">
      <mat-icon class="counter-icon" svgIcon="tracks-filter"></mat-icon>
      <span class="counter-value">{{tracksCounter}}</span>
    </span>
    <!-- <span class="counters-box">
      <mat-icon class="counter-icon-small" svgIcon="tracks-filter"></mat-icon>
      <span class="counter-value">{{sensorTracksCounter}}</span>
    </span> -->
    <span class="counters-box">
      <mat-icon class="counter-icon-medium" svgIcon="sensors-filter"></mat-icon>
      <span class="counter-value">{{sensorsCounter}}</span>
    </span>
    <span class="counters-box">
      <mat-icon class="counter-icon-medium" svgIcon="plots-filter"></mat-icon>
      <span class="counter-value">{{plotsCounter}}</span>
    </span>
    <span class="counters-box">
      <mat-icon class="counter-icon-medium" svgIcon="lines-filter" style="stroke-width: 1px;"></mat-icon>
      <span class="counter-value">{{vectorCounter}}</span>
    </span>
  </div>
</mat-card>
